import { styled, Theme } from '@mui/material';

import { Container } from '@components/Layout/components/Container';

export const sxStyles = {
  pageBg: {
    // TODO add colors to library
    backgroundColor: '#F9F9F9',
  },
  headSectionBg: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
  }),
  headSectionInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
  },
  awardType: {
    display: 'flex',
    alignItems: 'center',

    '& > svg:first-of-type': {
      marginRight: '0.625rem',
    },
  },
  programName: {
    margin: '0.75rem 0',
  },
  applyBtn: {
    minWidth: '142px',
    minHeight: '48px',
    fontWeight: '16px',
  },
  relatedSchoolsBg: (theme: Theme) => ({
    backgroundColor: theme.palette.common.white,
  }),
};

export const StyledHeadSectionInner = styled(Container)(({ theme }) => ({
  paddingBottom: '2rem',

  [theme.breakpoints.up('sm')]: {
    paddingBottom: '4rem',
  },
}));
